import React from "react";
import { useParams } from "react-router-dom";
import { SolutionTemplate } from "../../components/marketing/SolutionTemplate";
import { SOLUTIONS_BY_SLUG } from "../../data/solutionsData";
import NotFound from "../NotFound";

export default function SolutionPage() {
  const { slug } = useParams();
  const data = SOLUTIONS_BY_SLUG[slug];
  if (!data) return <NotFound />;
  return <SolutionTemplate data={data} />;
}
